/** Dispatched after a successful balance transfer to update list rows without refetching. */
export const PATCH_ADMIN_BALANCE_AFTER_TRANSFER = 'PATCH_ADMIN_BALANCE_AFTER_TRANSFER';
export const PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER = 'PATCH_SUPER_STOKEZ_BALANCE_AFTER_TRANSFER';
export const PATCH_STOKEZ_BALANCE_AFTER_TRANSFER = 'PATCH_STOKEZ_BALANCE_AFTER_TRANSFER';
export const PATCH_AGENT_BALANCE_AFTER_TRANSFER = 'PATCH_AGENT_BALANCE_AFTER_TRANSFER';
export const PATCH_PLAYER_BALANCE_AFTER_TRANSFER = 'PATCH_PLAYER_BALANCE_AFTER_TRANSFER';
